<mat-form-field appearance="outline">
  <!-- <mat-icon matPrefix
    class="mr-2">search</mat-icon> -->
  <mat-label>{{'COMMON.LABEL.SEARCH' | translate}}</mat-label>
  <input matInput
    [formControl]="searchFormControl"
    placeholder="{{'COMMON.LABEL.SEARCH' | translate}}">
  <!-- <mat-icon matSuffix
    (click)="cancelSearch()">close</mat-icon> -->
</mat-form-field>